import config from "../../../config/config";

function sanitizeFileName(fileName) {
  // Substitui caracteres não ASCII por um caractere permitido
  return fileName.replace(/[^\x00-\x7F]/g, '_');
}

async function generateToken() {
    try {
        const response = await fetch(`${config.apiUrl}auth-representative`, {
            method: 'POST',
        });
        const result = await response.json();
        return result.token;
    } catch (error) {
        console.error('Erro ao gerar token:', error);
        return null;
    }
}

// Função para fazer upload de arquivos
export const uploadFileToDropbox = async (file) => {
    const token = await generateToken();
    if (!token) {
        console.error('Token inválido');
        return null;
    }
    console.log('Token:', token);
    try {
      const response = await fetch(`${config.apiUrl}uploadToDropboxCv`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/octet-stream',
          'Authorization': `Bearer ${token}`,
          'file-name': sanitizeFileName(file.name) // Nome do arquivo pode ser passado como header
        },
        body: file // Envia o arquivo diretamente
      });
      
      const result = await response.json();
      if(response.status === 403) {
        alert('Esse link expirou. Por favor, recarregue a página e tente novamente.');
      }
      console.log('Upload bem-sucedido:', result);
      return result;
    } catch (error) {
      console.error('Erro ao fazer upload:', error.message);

      return null;
    }
  };
